import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import suitcss from '../../../helpers/suitcss';
import Headline from '../../basics/text/TextHeadline';
import Copy from '../../basics/text/TextCopy';
import FormSection from '../form/FormSection';
import FieldInputTan from '../../basics/form/FieldInputTan';
import connectUI from '../../basics/ui/UIConnector';
import { capitalize } from '../../../helpers/str';

const sBase = {
  componentName: 'TanInputForm',
};

const tanMethod2UiPrefix = (mfaMethod) => {
  const tanSource = {
    mTAN: 'sms',
    test_111111_TAN: 'sms',
    alternate_mTAN: 'smsAlt',
    ITAN: 'tanList',
  }[mfaMethod] || 'sms';

  return `mfaTan${capitalize(tanSource)}`;
};

const TanInputForm = ({
  fieldMap,
  mfaError,
  ui,
  mfaProcess,
  user,
  initiateError,
}) => {
  const error = mfaError || initiateError;
  const hasError = !!error;
  const uiPrefix = tanMethod2UiPrefix(mfaProcess?.mfaMethod);

  const subline = ui[`${uiPrefix}Subline`].replace('{MSISDN}', `<nobr>${user.phoneNumber}</nobr>`);

  return (
    <FormSection
      className={
        suitcss({
          ...sBase,
          modifiers: [hasError && 'error'],
        })
      }
      withoutBorder
    >
      <Headline element="h2" bold size="m">
        {ui[`${uiPrefix}Headline`]}
      </Headline>
      <Copy size="secondary" raw>
        {subline}
      </Copy>

      <Field
        maxLength={6}
        {...fieldMap.mfaTan}
        component={FieldInputTan}
        utilities={['col12']}
      />
      {error && (
        <div className={
          suitcss({
            ...sBase,
            descendantName: 'error',
          })
        }
        >
          {error.debugDetail}
          {' '}
          (
          {error.fullCode}
          )
        </div>
      )}
    </FormSection>
  );
};

TanInputForm.propTypes = {
  ui: PropTypes.object,
  fieldMap: PropTypes.object.isRequired,
  mfaError: PropTypes.object,
  mfaProcess: PropTypes.object,
  user: PropTypes.object,
  initiateError: PropTypes.object,
};

export default connectUI()(TanInputForm);
